export type Country = { iso: string; name: string; dial: string; min: number; max: number };

// El programa requiere autorización para trabajar en EE.UU.: dejamos EE.UU. y Puerto Rico
export const COUNTRIES: Country[] = [
  { iso: 'us', name: 'United States', dial: '1', min: 10, max: 10 },
  { iso: 'pr', name: 'Puerto Rico', dial: '1', min: 10, max: 10 },
];

export function flag(iso: string) {
  return iso.toUpperCase().replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));
}
